import {z} from 'zod';
import {creativeCardSchema} from '../../../../../schemas/creativeCardSchema';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {LandingPageSource} from 'common/src/modules/campaigns/campaigns.enums';
import {DTCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {CreativeTemplateFeature} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {CreativeNodeData} from 'common/src/modules/creatives/creatives.types';

export function convertCreativeAPICardToAICard(
  creativeCard: DTCreativeNode,
): z.output<typeof creativeCardSchema> {
  const features = getSupportedFeatureDetails(creativeCard.creative);

  const candidate: z.input<typeof creativeCardSchema> = {
    cardId: creativeCard.id,
    name: creativeCard.name ?? `Creative #${creativeCard.id}`,
    description: creativeCard.description ?? '',
    type: NodeType.CREATIVE,
    creativeId: creativeCard.creativeId,
    landingPageSource: creativeCard.landingPageSource ?? LandingPageSource.Campaign,
    isFallback: creativeCard.isFallbackCreative ?? false,
    features,
  } satisfies z.output<typeof creativeCardSchema>;

  return candidate;
}

function getSupportedFeatureDetails(creative: CreativeNodeData | undefined): string[] {
  const result: string[] = [];
  const features = creative?.features ?? [];

  if (features.includes(CreativeTemplateFeature.Feed)) {
    const format = creative?.formats?.[0];

    if (format && format.minItemCount != null && format.maxItemCount != null) {
      if (format.minItemCount === format.maxItemCount) {
        result.push(`Showing ${format.minItemCount} products`);
      } else {
        result.push(`Showing ${format.minItemCount}-${format.maxItemCount} products`);
      }
    } else {
      result.push('Showing Products');
    }
  }

  if (features.includes(CreativeTemplateFeature.Content)) {
    result.push('Showing Content');
  }

  if (features.includes(CreativeTemplateFeature.Location)) {
    result.push('Showing Location');
  }

  if (features.includes(CreativeTemplateFeature.Weather)) {
    result.push('Showing Weather');
  }

  return result;
}
